import './Footer.css';

function Footer() {
    return (

        <div id="footer">
            <div className="footer_info_title">
                © 2023 Moteam studio
            </div>

            <div className="footer_info_tel" > Tel 070-4633-2017</div>
            <div className="footer_info_address">
                Address Elice 2nd Floor, SeongsuNakNak, Seongsu-dong Seongdong-gu Seoul, Republic of Korea
            </div>
            <div className="footer_info_all">
                <p className="footer-info-bottom">Contact</p>
                <p className="footer-info-bottom">QA</p>
                <p className="footer-info-bottom"> Shiping and Return</p>
                <p className="footer-info-bottom">Terms of Use</p>
                <p className="footer-info-bottom">Privacy Policy</p>
                <p className="footer-info-bottom">Instagram</p>
            </div>
        </div>
        // <div id="footer">
        //     <div id="footer_box">
        //         <div id="footer_logo">
        //             <img src="" alt="company logo" />
        //         </div>
        //         <div id="address">
        //             <span>(주)회사</span> <span> | </span>
        //             <span>대표이사 삼모팀</span> <span> | </span>
        //             <span>사업자등록번호 : 123-34-12345</span>
        //             <ul>
        //                 {/* <li>(주)회사</li>
        //                 <li>사업자등록번호 : 123-34-12345</li>
        //                 <li>대표이사 삼모팀</li> */}
        //                 <li>이메일 : moTeam3333@gmail.com</li>
        //                 <li>주소(우편번호) 경기도 안양시 어쩌구 저쩌구</li>
        //                 <li>고객삼당실 : 02-123-456</li>
        //                 <li>영엽시간 : 평일 9:00 ~ 18:00 (점심시간 12:30 ~ 13:30)</li>
        //                 <li>토요일, 일요일, 공휴일 휴무</li>
        //             </ul>
        //             <p>Copyright ⓒMOTEAM CORPORATION. All Rights Reserved.</p>
        //         </div>
        //         <div>
        //             <div class="agree">
        //                 <ul>
        //                     <li>
        //                         <a href="#"><strong>개인정보처리방침</strong></a>
        //                     </li>
        //                     <li>
        //                         <a href="#">이용약관</a>
        //                     </li>
        //                 </ul>
        //             </div><br/>
        //             <div class="sns">
        //                 <ul>
        //                     <li>
        //                         <a href="#">
        //                             <img src="https://cdn-icons-png.flaticon.com/512/87/87390.png" alt="instagram" />
        //                         </a>
        //                     </li>
        //                      <li>
        //                         <a href="#">
        //                             <img src="https://cdn-icons-png.flaticon.com/512/2111/2111683.png" alt="kakaotalk" />
        //                         </a>
        //                     </li>
        //                     <li>
        //                         <a href="#">
        //                             <img src="https://cdn-icons-png.flaticon.com/512/747/747374.png" alt="facebook" />
        //                         </a>
        //                     </li>
        //                     <li>
        //                         <a href="#">
        //                             <img src="https://cdn-icons-png.flaticon.com/512/1077/1077046.png" alt="youtube" />
        //                         </a>
        //                     </li>
        //                 </ul>
        //             </div>
        //         </div>
        //     </div>
        // </div>
    )
}

export default Footer;
